import { render } from "./TemaIdentitetOgLikeverd.vue?vue&type=template&id=970c5c70&scoped=true"
import script from "./TemaIdentitetOgLikeverd.vue?vue&type=script&lang=js"
export * from "./TemaIdentitetOgLikeverd.vue?vue&type=script&lang=js"

import "./TemaIdentitetOgLikeverd.vue?vue&type=style&index=0&id=970c5c70&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-970c5c70"]])

export default __exports__